import { defineComponent as q, ref as p, computed as G, watch as H, nextTick as J, openBlock as h, createElementBlock as v, normalizeClass as O, unref as y, createElementVNode as Q, Fragment as T, renderList as V, withKeys as R, withModifiers as I, createVNode as U } from "vue";
import _ from "./index592.js";
import { basicMonthTableProps as W } from "./index939.js";
import { getValidDateOfMonth as X, datesInMonth as Z } from "./index862.js";
import ee from "./index938.js";
import { useNamespace as te } from "./index559.js";
import { useLocale as ae } from "./index597.js";
import { castArray as D } from "./index765.js";
import { hasClass as j } from "./index641.js";
const ne = ["aria-label"], oe = ["aria-selected", "aria-label", "tabindex", "onKeydown"];
var he = /* @__PURE__ */ q({
  __name: "basic-month-table",
  props: W,
  emits: ["changerange", "pick", "select"],
  setup(A, { expose: E, emit: B }) {
    const e = A, c = B, P = te("month-table"), { t: b, lang: g } = ae(), k = p(), w = p(), K = p(
      e.date.locale("en").localeData().monthsShort().map((a) => a.toLowerCase())
    ), L = p([[], [], []]), C = p(), N = p(), M = G(() => {
      var a, n, t;
      const s = L.value, o = _().locale(g.value).startOf("month");
      for (let l = 0; l < 3; l++) {
        const m = s[l];
        for (let d = 0; d < 4; d++) {
          const r = m[d] || (m[d] = {
            row: l,
            column: d,
            type: "normal",
            inRange: !1,
            start: !1,
            end: !1,
            text: -1,
            disabled: !1,
            isSelected: !1,
            customClass: void 0,
            date: void 0,
            dayjs: void 0,
            isCurrent: void 0,
            selected: void 0,
            renderText: void 0,
            timestamp: void 0
          });
          r.type = "normal";
          const f = l * 4 + d, i = e.date.startOf("year").month(f), u = e.rangeState.endDate || e.maxDate || e.rangeState.selecting && e.minDate || null;
          r.inRange = !!(e.minDate && i.isSameOrAfter(e.minDate, "month") && u && i.isSameOrBefore(u, "month")) || !!(e.minDate && i.isSameOrBefore(e.minDate, "month") && u && i.isSameOrAfter(u, "month")), (a = e.minDate) != null && a.isSameOrAfter(u) ? (r.start = !!(u && i.isSame(u, "month")), r.end = e.minDate && i.isSame(e.minDate, "month")) : (r.start = !!(e.minDate && i.isSame(e.minDate, "month")), r.end = !!(u && i.isSame(u, "month"))), o.isSame(i) && (r.type = "today");
          const S = i.toDate();
          r.text = f, r.disabled = ((n = e.disabledDate) == null ? void 0 : n.call(e, S)) || !1, r.date = S, r.customClass = (t = e.cellClassName) == null ? void 0 : t.call(e, S), r.dayjs = i, r.timestamp = i.valueOf(), r.isSelected = Y(r);
        }
      }
      return s;
    }), F = () => {
      var a;
      (a = w.value) == null || a.focus();
    }, z = (a) => {
      const n = {}, t = e.date.year(), s = /* @__PURE__ */ new Date(), o = a.text;
      return n.disabled = e.disabled || (e.disabledDate ? Z(e.date, t, o, g.value).every(
        e.disabledDate
      ) : !1), n.current = D(e.parsedValue).some(
        (l) => _.isDayjs(l) && l.year() === t && l.month() === o
      ), n.today = s.getFullYear() === t && s.getMonth() === o, a.customClass && (n[a.customClass] = !0), a.inRange && (n["in-range"] = !0, a.start && (n["start-date"] = !0), a.end && (n["end-date"] = !0)), n;
    }, Y = (a) => {
      const n = e.date.year(), t = a.text;
      return D(e.date).some(
        (s) => s.year() === n && s.month() === t
      );
    }, $ = (a) => {
      var n;
      if (!e.rangeState.selecting) return;
      let t = a.target;
      if (t.tagName === "SPAN" && (t = (n = t.parentNode) == null ? void 0 : n.parentNode), t.tagName === "DIV" && (t = t.parentNode), t.tagName !== "TD") return;
      const s = t.parentNode.rowIndex, o = t.cellIndex;
      M.value[s][o].disabled || (s !== C.value || o !== N.value) && (C.value = s, N.value = o, c("changerange", {
        selecting: !0,
        endDate: e.date.startOf("year").month(s * 4 + o)
      }));
    }, x = (a) => {
      var n;
      if (e.disabled) return;
      const t = (n = a.target) == null ? void 0 : n.closest(
        "td"
      );
      if (t?.tagName !== "TD" || j(t, "disabled")) return;
      const s = t.cellIndex, l = t.parentNode.rowIndex * 4 + s, m = e.date.startOf("year").month(l);
      if (e.selectionMode === "months") {
        if (a.type === "keydown") {
          c("pick", D(e.parsedValue), !1);
          return;
        }
        const d = X(
          e.date,
          e.date.year(),
          l,
          g.value,
          e.disabledDate
        ), r = j(t, "current") ? D(e.parsedValue).filter(
          (f) => (
            // Filter out the selected month only when both year and month match
            // This allows remove same months from different years #20019
            f?.year() !== d.year() || f?.month() !== d.month()
          )
        ) : D(e.parsedValue).concat([_(d)]);
        c("pick", r);
      } else e.selectionMode === "range" ? e.rangeState.selecting ? (e.minDate && m >= e.minDate ? c("pick", { minDate: e.minDate, maxDate: m }) : c("pick", { minDate: m, maxDate: e.minDate }), c("select", !1)) : (c("pick", { minDate: m, maxDate: null }), c("select", !0)) : c("pick", l);
    };
    return H(
      () => e.date,
      async () => {
        var a, n;
        (a = k.value) != null && a.contains(document.activeElement) && (await J(), (n = w.value) == null || n.focus());
      }
    ), E({
      /**
       * @description focus current cell
       */
      focus: F
    }), (a, n) => (h(), v("table", {
      role: "grid",
      "aria-label": y(b)("el.datepicker.monthTablePrompt"),
      class: O(y(P).b()),
      onClick: x,
      onMousemove: $
    }, [
      Q(
        "tbody",
        {
          ref_key: "tbodyRef",
          ref: k
        },
        [
          (h(!0), v(
            T,
            null,
            V(M.value, (t, s) => (h(), v("tr", { key: s }, [
              (h(!0), v(
                T,
                null,
                V(t, (o, l) => (h(), v("td", {
                  key: l,
                  ref_for: !0,
                  ref: (m) => o.isSelected && (w.value = m),
                  class: O(z(o)),
                  "aria-selected": !!o.isSelected,
                  "aria-label": y(b)(`el.datepicker.month${+o.text + 1}`),
                  tabindex: o.isSelected ? 0 : -1,
                  onKeydown: [
                    R(I(x, ["prevent", "stop"]), ["space"]),
                    R(I(x, ["prevent", "stop"]), ["enter"])
                  ]
                }, [
                  U(y(ee), {
                    cell: {
                      ...o,
                      renderText: y(b)("el.datepicker.months." + K.value[o.text])
                    }
                  }, null, 8, ["cell"])
                ], 42, oe))),
                128
                /* KEYED_FRAGMENT */
              ))
            ]))),
            128
            /* KEYED_FRAGMENT */
          ))
        ],
        512
        /* NEED_PATCH */
      )
    ], 42, ne));
  }
});
export {
  he as default
};
